import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style/InteriorLanding.css"; // Assuming you have a CSS file for styles
import TestimonialSection from "./TestimonialSection";
import FAQSection from "./FAQSection";
// import ContactUs from "./ContactUs";N
// import HeroSlider from "./HeroSlider";

const services = [
  {
    title: "Office Interior Furniture",
    description: 'Custom-designed kitchens with modern fittings, cabinets, and smart layouts.',
     image: "/assets/office.webp",
  },
  {
    title: "School Interior Furniture",
    description: 'Space-optimized wardrobes with stylish designs tailored to your room.',
     image: "/assets/school.webp",
  },
  {
    title: "College Interior Furniture",
    description: 'Decorative ceilings with lighting and design enhancements.',
     image: "/assets/college.webp",
  },
  {
    title: "Lab Interior Furniture",
    description: 'Functional and elegant entertainment unit designs.',
    image: "/assets/lab.webp",
  },
  {
    title: "Office Interior Designing",
    description: 'Creative and cozy interiors to elevate your living space.',
    image: "/assets/offint.webp",
  },
  {
    title: "Hotel Furnitures",
    description: 'Relaxing and aesthetic bedroom layouts and decor.',
     image: "/assets/hotel.webp",
  },
  {
    title: "Restaurant Furniture",
    description: 'Professional painting with high-quality finishes.',
     image: "/assets/restaurant.webp",
  },
  {
    title: "Sofa Furnitures",
    description: 'Ambient lighting setups for enhanced mood and style.',
     image: "/assets/sofa.webp",
  },
];

export default function InteriorLanding() {

  const [formData, setFormData] = useState({ name: "", phone: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Client-side validation
    if (!formData.name.trim()) {
      toast.error("Please enter your name");
      return;
    }

    if (!formData.phone.trim()) {
      toast.error("Please enter your phone number");
      return;
    }

    const phoneRegex = /^[0-9]{10,15}$/;
    if (!phoneRegex.test(formData.phone)) {
      toast.error("Please enter a valid phone number (10 to 15 digits)");
      return;
    }

    try {
      const response = await fetch(
        "https://shalishaenterprise.com/backend/submit_form.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok && data.apiresponse?.code === "0000") {
        toast.success(data.apiresponse.message || "Message sent successfully!");
        setFormData({ name: "", phone: "" });

        setTimeout(() => {
          window.location.href =
            "https://shalishaenterprise.com/backend/thank_you.php";
        }, 2000);
      } else {
        toast.error(data.apiresponse?.message || "Failed to send message");
      }
    } catch (err) {
      toast.error("An error occurred. Please try again.");
      console.error("Form error:", err);
    }
  };

  return (
    <>
    <section
  id="enquiry"
  className="slider"
  style={{
    backgroundImage: `url(${"./assets/interiordesign.webp"})`, // Update with a furniture image
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="container">
    <div className="row align-items-center">
      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8">
    <ToastContainer />
        <div className="slide__content text-white">
          <h2 className="slide__title">Interior Design And<br/>Furniture Collection</h2> 
          <p className="slide__desc">
            Elevate your home with our exquisite furniture collection. From modern to classic styles, find the perfect pieces to match your taste. Book a FREE consultation today!
          </p>
        </div>
      </div>

      <div className="col-sm-4 col-md-4 mobileview">
        <div className="intro-form bg-white p-4 rounded shadow">
          <h4>Furnish Your Home with Style</h4> {/* Updated heading */}
          <form onSubmit={handleSubmit} noValidate> {/* ✅ no action here */}
                  <fieldset>
                    <input
                      placeholder="Name"
                      required
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control mb-2"
                    />
                    <input
                      placeholder="Mobile No."
                      required
                      type="tel"
                      name="phone"
                      className="form-control mb-3"
                      minLength="10"
                      maxLength="15"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    <button
                      className="btn btn-block btn-lg btn-orange"
                      type="submit"
                    >
                      Submit Now
                    </button>
                  </fieldset>
                </form>

        </div>
      </div>
    </div>
  </div>
</section>
<section className="interior-section text-white py-5">
    <div className="container">
      <h2 className="section-heading text-center mb-5">
        Your one-stop solution for all interior design needs
      </h2>
      <div className="row">
        {services.map((service, index) => (
          <div className="col-lg-3 col-md-6 mb-4" key={index}>
            <div className="service-card">
            <div className="service-image-wrapper" data-aos="zoom-in">
              <img src={service.image} alt={service.title} className="img-fluid" />
            </div>
              <div className="service-info">
                <h5 className="service-title text-center">{service.title}</h5>
                <a href="#enquiry" className="btn btn-sm w-100  btn-interior p-2">Send Enquiry</a>
                
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
<TestimonialSection />
<FAQSection />
    </>
  );
}



//   import React from "react";
//   import "bootstrap/dist/css/bootstrap.min.css";
//   import "./style/InteriorLanding.css"; // Assuming you have a CSS file for styles
//   // import HeroSlider from "./HeroSlider";
//   const interior = [
//     {
//       title: "Office Interior Furniture",
//       image: "/assets/office.webp",
//     },
//     {
//       title: "School Interior Furniture",
//       image: "/assets/school.png",
//     },
//     {
//       title: "College Interior Furniture",
//       image: "/assets/college.png",
//     },
//     {
//       title: "Lab Interior Furniture Net",
//       image: "/assets/lab.png",
//     },
//     {
//       title: "Office Interior Designing",
//       image: "/assets/offint.png",
//     },
//     {
//       title: "Hotel Furnitures",
//       image: "/assets/hotel.png",
//     },
//     {
//       title: "Restaurant Furniture",
//       image: "/assets/restaurant.png",
//     },
//     {
//       title: "Sofa Furnitures",
//       image: "/assets/sofa.png",
//     },
//   ];

//   const services = [
//     {
//       title: "Office Interior Furniture",
//       description: 'Custom-designed kitchens with modern fittings, cabinets, and smart layouts.',
//        image: "/assets/office.png",
//     },
//     {
//       title: "School Interior Furniture",
//       description: 'Space-optimized wardrobes with stylish designs tailored to your room.',
//        image: "/assets/school.png",
//     },
//     {
//       title: "College Interior Furniture",
//       description: 'Decorative ceilings with lighting and design enhancements.',
//        image: "/assets/college.png",
//     },
//     {
//   title: "Lab Interior Furniture",
//       description: 'Functional and elegant entertainment unit designs.',
//        image: "/assets/lab.png",
//     },
//     {
//   title: "Office Interior Designing",
//       description: 'Creative and cozy interiors to elevate your living space.',
//        image: "/assets/offint.png",
//     },
//     {
//       title: "Hotel Furnitures",
//       description: 'Relaxing and aesthetic bedroom layouts and decor.',
//        image: "/assets/hotel.png",
//     },
//     {
//       title: "Restaurant Furniture",
//       description: 'Professional painting with high-quality finishes.',
//        image: "/assets/restaurant.png",
//     },
//     {
//       title: "Sofa Furnitures",
//       description: 'Ambient lighting setups for enhanced mood and style.',
//        image: "/assets/sofa.png",
//     },
//   ];
  
//   export default function InteriorLanding() {
//     return (
//       <>

// <section className="interior-section text-white py-5">
//       <div className="container">
//         <p className="section-label text-center">ISSUES WE REPAIR</p>
//         <h2 className="section-heading text-center mb-5">
//           Your one-stop solution for all interior design needs
//         </h2>
//         <div className="row">
//           {services.map((service, index) => (
//             <div className="col-lg-3 col-md-6 mb-4" key={index}>
//               <div className="service-card">
//                 <div className="service-image-wrapper">
//                   <img src={service.image} alt={service.title} className="img-fluid" />
//                 </div>
//                 <div className="service-info">
//                   <h5 className="service-title">{service.title}</h5>
//                   <p className="service-description">{service.description}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//       <section
//     id="enquiry"
//     className="slider"
//     style={{
//       backgroundImage: `url(${"./assets/interiordesign.jpg"})`, // Update with a furniture image
//       backgroundSize: "cover",
//       backgroundPosition: "center",
//       backgroundRepeat: "no-repeat",
//     }}
//   >
//     <div className="container">
//       <div className="row align-items-center">
//         <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8">
//           <div className="slide__content text-white">
//             <h2 className="slide__title">Interior Design And<br/>Furniture Collection</h2> 
//             <p className="slide__desc">
//               Elevate your home with our exquisite furniture collection. From modern to classic styles, find the perfect pieces to match your taste. Book a FREE consultation today!
//             </p>
//           </div>
//         </div>

//         <div className="col-sm-4 col-md-4 tabresponsive mobileview">
//           <div className="intro-form bg-white p-4 rounded shadow">
//             <h4>Furnish Your Home with Style</h4> {/* Updated heading */}
//             <form action="submit.php" method="POST">
//               <input name="form-type" value="contact" type="hidden" />
//               <fieldset>
//                 <input placeholder="Name" required type="text" name="name" />
//                 <input
//                   placeholder="Mobile No."
//                   type="tel"
//                   name="mobile"
//                   className="form-control"
//                   minLength="10"
//                   maxLength="15"
//                   required
//                 />
//                 <button className="btn btn-block btn-lg btn-orange" type="submit">
//                   Submit Now
//                 </button>
//               </fieldset>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   </section>

      
//       {/* <div className="interior-wrapper bg-dark text-center py-5 px-3">
//         <h2 className="fw-bold my-4">What We Offer</h2>

//         <div className="container">
//           <div className="row g-4 justify-content-center">
//             {interior.map((interior, index) => (
//               <div key={index} className="col-12 col-sm-6 col-lg-4">
//                 <div className="interior-card rounded-4 overflow-hidden h-100">
//                   <img
//                     src={interior.image}
//                     alt={interior.title}
//                     className="interior-image"
//                   />
//                   <div className="p-1">
//                     <h5 className="interior-title text-light">{interior.title}</h5>
//                     <a href="#enquiry" className="btn btn-sm w-100  btn-interior p-2">Send Enquiry</a>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div> */}

//       </>
//     );
//   }

  // import React from 'react';
  // // import './style/Services.css'; 
  // const ServiceItem = ({ iconSrc, title, description, link }) => {
  //   return (
  //     <div className="col-sm-12 col-md-6 col-lg-4">
  //       <div className="service-item bg-img">
  //       {/* <div className="service-item bg-img" style={{ backgroundImage: 'url(undefined)', backgroundSize: 'cover', backgroundPosition: 'center center' }}> */}
  //         <div className="service__body">
  //           <div className="service__icon">
  //             <i><img src={iconSrc} width="100px" alt="service icon" /></i>
  //           </div>
  //           <h4 className="service__title">{title}</h4>
  //           <p className="service__desc">{description}</p>
  //           <a href={link} className="btn btn__secondary btn__block d-flex justify-content-between">
  //             <span>Read More</span>
  //             <i className="icon-arrow-right icon-outlined"></i>
  //           </a>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  // const Services = () => {
  //   return (
  //     <section className="services-layout1 services-carousel pt-60 pb-60 bg-img" style={{ backgroundImage: 'url("assets/images/backgrounds/3.png")', backgroundSize: 'cover', backgroundPosition: 'center center' }}>
  //       <div className="container">
  //         <div className="row">
  //           <div className="col-sm-12 col-md-12 col-lg-6 offset-lg-3">
  //             <div className="heading text-center mb-60">
  //               <h3 className="heading__title">Specialist Disinfection Services That Fits Your Premises</h3>
  //             </div>
  //           </div>
  //         </div>
  //         <div className="row">
  //           {/* Add all service items here */}
  //           <ServiceItem 
  //             iconSrc="assets/termite.png" 
  //             title="Office Furniture"
  //             description="Termites are wood-destroying insects that can cause extensive damage to homes and structures. They feed on cellulose, weakening wood and compromising..."
  //             link="termite-control.html"
  //           />
  //           <ServiceItem 
  //             iconSrc="assets/cockroach.png" 
  //             title="School Furniture"
  //             description="Eradicate cockroaches with our expert control services. Say goodbye to these resilient pests and enjoy a pest-free, hygienic environment."
  //             link="cockroach.html"
  //           />
  //           <ServiceItem 
  //             iconSrc="assets/bedbug.png" 
  //             title="College Furniture"
  //             description="Eliminate bed bugs with our expert control services. Sleep soundly knowing we've eradicated these troublesome pests from your home."
  //             link="bedbugs.html"
  //           />
  //           <ServiceItem 
  //             iconSrc="assets/rodent.png" 
  //             title="Lab Furniture"
  //             description="Rodent control experts at your service. We'll swiftly and safely remove these unwelcome guests, ensuring a pest-free environment for you."
  //             link="rodent.html"
  //           />
  //           <ServiceItem 
  //             iconSrc="assets/woodborer.png" 
  //             title="Office Interior Designing"
  //             description="Protect your wood structures from damage. Our wood borer control experts ensure the preservation of your investments with effective treatments."
  //             link="woodborer.html"
  //           />
  //           <ServiceItem 
  //             iconSrc="assets/aint.png" 
  //             title="Hotel Furnitures"
  //             description="Ant Control: Your trusted solution for a pest-free environment. We eliminate nuisances swiftly and effectively, safeguarding your property and well-being."
  //             link="aint.html"
  //           />
  //           <ServiceItem 
  //             iconSrc="assets/general pest.png" 
  //             title="Restaurant Furniture"
  //             description="General pest control: We combat common pests, ensuring homes and businesses remain pest-free, protecting property, health, and peace of mind."
  //             link="generalpest.html"
  //           />
  //           <ServiceItem 
  //             iconSrc="assets/dog ticks.png" 
  //             title="Dog Ticks"
  //             description="Combat dog ticks: Protect your pet's health with regular checks and preventative measures. Consult your vet for tick control guidance."
  //             link="dogticks.html"
  //           />
  //         </div>
  //       </div>
  //     </section>
  //   );
  // };

  // export default Services;
